var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.getClassName("sizes") }, [
    _vm.item.sizes.length > 0
      ? _c(
          "ul",
          { class: _vm.getClassName("sizes__items") },
          _vm._l(_vm.item.sizes, function(size) {
            return _c(
              "li",
              { key: size.id, class: _vm.getClassName("sizes__item") },
              [
                _c(
                  "label",
                  {
                    class: _vm
                      .getClassNameActive(
                        "sizes__action",
                        size,
                        _vm.value.item_size_id
                      )
                      .concat([
                        _vm.isDisabled(size.id)
                          ? "sizes__action--disabled"
                          : null
                      ]),
                    attrs: { for: _vm.uuid + "-" + size.id }
                  },
                  [
                    _c("div", { class: _vm.getClassName("sizes__name") }, [
                      _vm._v("\n          " + _vm._s(size.name)),
                      _c("br"),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.getSizePrice(size.id)) +
                          "円（税込）\n          "
                      ),
                      _c("div", { class: _vm.getClassName("sizes__stock") }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.getStock(size.id)) +
                            "\n          "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.internalValue,
                          expression: "internalValue"
                        },
                        {
                          name: "show",
                          rawName: "v-show",
                          value: false,
                          expression: "false"
                        }
                      ],
                      attrs: {
                        type: "radio",
                        id: _vm.uuid + "-" + size.id,
                        disabled: _vm.isDisabled(size.id)
                      },
                      domProps: {
                        value: size.id,
                        checked: _vm._q(_vm.internalValue, size.id)
                      },
                      on: {
                        change: function($event) {
                          _vm.internalValue = size.id
                        }
                      }
                    })
                  ]
                )
              ]
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }